import { Grid } from '@material-ui/core';
import {
  EntityLayout,
  EntityLinksCard,
  EntitySwitch
} from '@backstage/plugin-catalog'
import {
  EntityGroupProfileCard,
  EntityMembersListCard,
  EntityOwnershipCard
} from '@backstage/plugin-org';
import { Entity } from '@backstage/catalog-model';
import {
  EntityGithubGroupPullRequestsCard,
  isGithubTeamPullRequestsAvailable,
} from '@roadiehq/backstage-plugin-github-pull-requests';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { defaultEntityWarningContent } from './EntityWarningContent';
import { hasLinks } from './hasLinks';
import { Config } from '@backstage/config';

const isEnableGitHubGroupPullRequests = (entity: Entity, config: Config): boolean => {
  const enableGitHubGroupPullRequests = config.getOptionalBoolean('platt.group.githubPullRequests.enabled') ?? false;
  return enableGitHubGroupPullRequests && isGithubTeamPullRequestsAvailable(entity);
};

const GitHubPullRequestsCard = () => {
  const config = useApi(configApiRef);

  return (
    <>
      <EntitySwitch>
        <EntitySwitch.Case if={e => (isEnableGitHubGroupPullRequests(e, config))}>
          <Grid item md={6} xs={12}>
            <EntityGithubGroupPullRequestsCard/>
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>
    </>
  );
};

export type GroupPageProps = {
  additionalCard?: React.JSX.Element;
  additionalRoute?: React.JSX.Element;
  entityWarningContent?: React.JSX.Element;
};
export const groupPage = (props?: GroupPageProps) => {

  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3}>
          {props?.entityWarningContent ?? defaultEntityWarningContent}
          <Grid item xs={12} md={6}>
            <EntityGroupProfileCard />
          </Grid>
          <Grid item xs={12} md={6}>
            <EntityOwnershipCard />
          </Grid>

          <GitHubPullRequestsCard />

          <EntitySwitch>
            <EntitySwitch.Case if={hasLinks}>
              <Grid item xs={12} md={6}>
                <EntityLinksCard />
              </Grid>
            </EntitySwitch.Case>
          </EntitySwitch>

          {props?.additionalCard}
          
          <Grid item xs={12} md={6}>
            <EntityMembersListCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
      {props?.additionalRoute}
    </EntityLayout>
  );
};

